(function () {
  const body = document.body;
  const STORAGE_KEY = 'daeker-scribble-active';
  const SCRIBBLE_HIDE_MS = 150;

  function showScribble() {
    body.classList.add('daeker-scribble-active');
    body.classList.remove('daeker-scribble-hidden');
  }

  function hideScribble() {
    body.classList.remove('daeker-scribble-active', 'daeker-scribble-hidden');
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function shouldTrackNavigation(link) {
    if (!link || !link.href) return false;
    if (link.target === '_blank') return false;
    if (link.hasAttribute('download')) return false;
    if (link.closest('[data-no-page-loader]')) return false;
    if (link.closest('modal-opener, modal-dialog, quick-add-modal')) return false;
    if (link.hasAttribute('aria-haspopup')) return false;

    const href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('#')) return false;
    if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return false;

    try {
      const url = new URL(link.href);
      if (url.origin !== window.location.origin) return false;
    } catch (error) {
      return false;
    }

    return true;
  }

  if (
    document.documentElement.classList.contains('shopify-design-mode') ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const link = event.target.closest('a[href]');
      if (!shouldTrackNavigation(link)) return;

      sessionStorage.setItem(STORAGE_KEY, '1');
      showScribble();
    },
    true
  );

  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    showScribble();

    function finishScribble() {
      window.setTimeout(hideScribble, SCRIBBLE_HIDE_MS);
    }

    if (document.readyState === 'complete') {
      finishScribble();
    } else {
      window.addEventListener('load', finishScribble, { once: true });
    }
  }
})();
